var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"radio-button-navigation"},_vm._l((_vm.links),function(ref){
var name = ref.name;
var url = ref.url;
return _c('li',{key:name,staticClass:"radio-button-navigation-item",class:{ active: _vm.isLinkActive(url) }},[_c('a',{staticClass:"radio-button-navigation-link",class:{ active: _vm.isLinkActive(url) },attrs:{"href":url},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(name)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }